import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { ToastContainer } from 'react-toastify';

import InvoiceEdit from './components/InvoiceEdit';
import InvoiceNew from './components/InvoiceNew';
import InvoiceShow from './components/InvoiceShow';
import InvoiceTable from './components/InvoiceTable';

function App() {
  return (
    <>
      <Helmet defaultTitle="Invoices" />
      <div className="px-5">
        <Router>
          <Routes>
            <Route path="/invoices/:id" element={<InvoiceShow />}>
              <Route path="edit" element={<InvoiceEdit />} />
            </Route>
            <Route path="/" element={<InvoiceTable />}>
              <Route path="new" element={<InvoiceNew />} />
            </Route>
          </Routes>
        </Router>
        <ToastContainer />
      </div>
    </>
  );
}

export default App;
